// 内部片（`_` 前缀）：转接面板的目标类型、振铃转接目标与「常用目标收藏」本地存储。
// 仅供 QuickDialBar/TransferPopover 使用，入口不重导出本文件。

/** 内部转接目标类型：技能组/坐席/话机 */
export type TransferTargetType = 'skill_group' | 'agent' | 'extension';

/** 振铃态（未接听）转接目标：技能组给队列键 code，坐席/话机给分机号（后端受控转接） */
export interface RingTarget {
  queue?: string;
  extension?: string;
}

const SHIFT_TABS: { key: TransferTargetType; label: string }[] = [
  { key: 'skill_group', label: '技能组' },
  { key: 'agent', label: '坐席' },
  { key: 'extension', label: '话机' },
];

/** 转接目标类型胶囊 Tab（技能组 / 坐席 / 话机） */
export { SHIFT_TABS };

/** 常用转接目标收藏（localStorage，全坐席本地记忆） */
const TRANSFER_FAV_KEY = 'bcc-transfer-favs';
export function readTransferFavs(): string[] {
  try {
    const a = JSON.parse(window.localStorage.getItem(TRANSFER_FAV_KEY) || '[]');
    return Array.isArray(a) ? a.map(String) : [];
  } catch {
    return [];
  }
}
export function writeTransferFavs(a: string[]) {
  try {
    window.localStorage.setItem(TRANSFER_FAV_KEY, JSON.stringify(a));
  } catch {
    /* 忽略 */
  }
}
